import React from "react"
import { StaticQuery, graphql } from "gatsby"
import moment from "moment";

export default props => (
  <StaticQuery
    query={graphql`
      query RestaurantsQuery {
        allContentfulRestauranger(limit: 1000) {
          edges {
            node {
              id
              title
              restaurantType
              coords{
                lat
                lon
              }
              openingHours
            }
          }
        }
      }
    `}
    render={data => {

      let restaurants = data.allContentfulRestauranger.edges;
      restaurants = restaurants.sort((a,b) => {
        return a.node.title > b.node.title;
      });

      return (
        <div className="container text-outer tight">
          <div className="row justify-content-center">
            <div className="col-6 col-md-6">
              <input type="text" className="form-control text-center mb-3" onChange={props.handleInputChange}
                     value={props.name} name="name" placeholder="Namn"/>
            </div>
            <div className="col-6 col-md-6">
              <input min="0" maxLength="10" inputMode="numeric" type="tel"
                     className="form-control text-center mb-3" onChange={props.handleInputChange}
                     value={props.mobile} name="mobile" placeholder="Mobilnr"/>
            </div>
            <div className="col-12">
              <div className="btn-group btn-group-toggle mb-3" data-toggle="buttons">
                <label className={(props.delivery === 'upphämtning' ? 'active' : '') + " btn btn-default"}>
                  <input type="radio" name="delivery" autoComplete="off" checked={props.delivery === 'upphämtning'} value="upphämtning" onChange={props.handleInputChange} /> Upphämtning
                </label>
                <label className={(props.delivery === 'leverans' ? 'active' : '') + " btn btn-default"}>
                  <input type="radio" name="delivery" autoComplete="off" checked={props.delivery === 'leverans'} value="leverans" onChange={props.handleInputChange} /> Leverans
                </label>
              </div>
            </div>
            <div className="col-12">
              {props.delivery === 'upphämtning' && (
                <select
                  name="restaurant"
                  className="form-control mb-3 "
                  style={{'text-align-last':'center',}}
                  value={props.restaurant || -1}
                  onChange={props.handleInputChange}>
                  <option value='-1' disabled={true}>Välj restaurang</option>
                  {restaurants.map(restaurant =>
                    <option key={restaurant.node.id} value={restaurant.node.title}>{restaurant.node.title}</option>
                  )}
                </select>
              )}
              {props.delivery === 'leverans' && (
                <div>
                  <div className="text-center mb-3" style={{fontSize:'.9rem'}}>Vid leverans tillkommer en leveransavgift på 300 - 500kr</div>
                  <input type="text"
                         className="form-control mb-3" onChange={props.handleInputChange}
                         value={props.address} name="address" placeholder="Ange leveransadress"/>
                </div>

              )}
            </div>
            <div className="col-6">
              <button className="btn btn-default mb-3" onClick={props.openDatePicker}>
                {props.date ? moment(props.date).format('YYYY-MM-DD') : 'Ange datum'}
              </button>
            </div>
            <div className="col-6">
              <select
                name="time"
                className="form-control mb-3 text-center"
                style={{'text-align-last':'center',}}
                value={props.time || -1}
                onChange={props.handleInputChange}>
                <option value={-1} disabled>Ange tid</option>
                {['11','12','13','14','15','16','17','18','19','20'].map(time => {
                  return ([
                    <option key={time+':00'} value={time+':00'}>{time+':00'}</option>,
                    <option key={time+':30'} value={time+':30'}>{time+':30'}</option>
                  ])
                })}
                <option value="21:00">21:00</option>
              </select>
            </div>
            <div className="col-12">
              <textarea
                onChange={props.handleInputChange}
                className="form-control mb-3"
                placeholder="Ytterligare information / önskemål till kocken"
                name="extraInfo"
                value={props.extraInfo} />
            </div>
            <div className="col-12 col-md-8 col-md-push-2 col-lg-6 col-lg-push-3">
              <button className="btn btn-block btn-primary" onClick={props.handleSenderClick}>Skicka</button>
            </div>
          </div>
        </div>
      );
    }}
  />
)
